import sendAiGenItemLoadAnalytics from '@/utils/analytics/sendAiGenItemLoadAnalytics';

import type { AnalyticsSettings } from './analyticsSettings';

/** Send analytics for generation success */
const sendGenerateSuccessAnalytics = (
  processingTime: number,
  settings: AnalyticsSettings
) => {
  sendAiGenItemLoadAnalytics({
    result: 'success',
    processing_time: processingTime,
    settings,
  });
};

export default sendGenerateSuccessAnalytics;
